const loadRecaptcha = require('./loadRecaptcha').default
const useRecaptcha = require('./useRecaptcha').default

module.exports = {
  loadRecaptcha,
  useRecaptcha
}
